export const WA_PHONE = "6281337299147";
export const WA_DISPLAY = "+62 813-3729-9147";
export const CONTACT_EMAIL = "agungwiwinhomestaycanggu@gmail.com";
export const LOCATION = "Pererenan, Canggu — Bali, Indonesia";
export const INSTAGRAM = "https://instagram.com/agungwiwinhomestay";
export const FACEBOOK = "https://facebook.com/agungwiwinhomestay";

export function waUrl(text) {
  return `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(text)}`;
}

export const BOOK_MESSAGE = (roomName = "") =>
  `Hello Agung Wiwin Homestay,\n\nI would like to inquire about room availability.\n\nRoom Type: ${roomName}\nCheck-in Date: \nCheck-out Date: \nNumber of Guests: \n\nThank you.`;

export const ORDER_MESSAGE = (item = "") =>
  `Hello The Garden Cafe,\n\nI would like to place an order.\n\nMenu Item: ${item}\nRoom Number: \nSpecial Request: \n\nThank you.`;

export const LAUNDRY_MESSAGE = (service = "") =>
  `Hello Agung Wiwin Laundry,\n\nI would like to request a laundry service.\n\nService: ${service}\nPickup Address / Room: \nApprox. Weight (kg): \n\nThank you.`;
